
import { useCallback } from 'react';

import { dataLayerPush } from '@r1-frontend/analytics/dataLayerPush';

import { EVENTS } from '@r1-frontend/shared/constants/analytics';
import { isClientSide } from '@r1-frontend/shared/helpers/ssr';

const analiticsSender = (category: string, action: string, label?: string) => {
    isClientSide() && dataLayerPush({
        event: EVENTS.UAevent,
        category,
        action,
        label,
    });
};

/**
 * Возвращает функцию для отправки аналитики
 */
export const useAnalyticsSender = (category: string) => {
    return useCallback((action: string, label?: string): void => {
        analiticsSender(category, action, label);
    }, [category]);
};

/**
 * Возвращает функцию для отправки аналитики, без useCallback
 */
export const getAnalyticsSender = (category: string) => {
    return (action: string, label?: string): void => {
        analiticsSender(category, action, label);
    };
};
